import React, { ComponentProps, PropsWithChildren } from "react";

import { useLabels } from "../../../hooks/useLabels";
import { Modal } from "../../modal";
import { ConfirmDialog } from "./confirm-dialog";

export const ConfirmDialogContainer = ({
	children,
	onOk,
	onCancel,
	messageLabel,
	messageHtmlLabel,
	messageHtmlReplacements,
	okLabel,
	cancelLabel,
	titleLabel,
	isOkDisabled,
	...modalProps
}: PropsWithChildren<
	{
		titleLabel: eXpress.creator.LabelRequest;
		okLabel: eXpress.creator.LabelRequest;
		isOkDisabled?: boolean;
		cancelLabel: eXpress.creator.LabelRequest;
		messageLabel?: eXpress.creator.LabelRequest;
		messageHtmlLabel?: eXpress.creator.LabelRequest;
		messageHtmlReplacements?: string[];
	} & Pick<ComponentProps<typeof ConfirmDialog>, "onOk" | "onCancel"> &
		ComponentProps<typeof Modal>
>) => {
	const [[ok, cancel, title, messageHtml, message], areLabelsLoading] = useLabels([
		okLabel,
		cancelLabel,
		titleLabel,
		messageHtmlLabel,
		messageLabel,
	]);

	if (areLabelsLoading) return null;

	return (
		<ConfirmDialog
			title={title}
			cancel={cancel}
			ok={ok}
			onOk={onOk}
			isOkDisabled={isOkDisabled}
			onCancel={onCancel}
			messageHtml={
				messageHtmlReplacements && messageHtml
					? eXpress.utils.formatString(messageHtml, ...messageHtmlReplacements)
					: messageHtml
			}
			{...modalProps}
		>
			{message}
			{children}
		</ConfirmDialog>
	);
};
ConfirmDialogContainer.displayName = "ConfirmDialogContainer";
